import {catchError, map, Observable} from 'rxjs';

import {FormCycleType, ICycle, IToFormRequest} from '@core/api/data-access';
import {DcError} from '@shared-types';

import {CyclesService} from './cycles.service';

type CycleID = ICycle['id'];

export class CycleOperationsCyclesService {
	constructor(private cyclesService: CyclesService) {}

	public toForm(cycleId: string, formType: FormCycleType): Observable<CycleID> {
		const request: IToFormRequest = {
			cycleId,
			status: formType,
		};
		return this.cyclesService.apiService.post<CycleID, IToFormRequest>(this.cyclesService.getUrl('template'), request).pipe(
			map(() => cycleId),
			catchError(error => {
				throw DcError({
					captureToSentry: true,
					name: 'Failed to convert cycle to form',
					message: error.message,
					originalError: error,
					source: 'CyclesService -> Cycle -> Operations -> toForm(...)',
					type: 'backend',
				});
			}),
		);
	}
}
